$(document).ready(function() {
    initApiTokens();
});

function initApiTokens() {
    setupRevokeTokenModal();
    setupAdminScopeWarning();
    setupScopeValidation();
}

function setupRevokeTokenModal() {
    var $revokeModal = $('#revokeTokenModal');
    if (!$revokeModal.length) return;

    $revokeModal.on('show.bs.modal', function(event) {
        var button = event.relatedTarget;
        var tokenId = $(button).data('token-id');
        var tokenName = $(button).data('token-name');

        $('#revokeTokenName').text(tokenName);

        var $form = $('#revokeTokenForm');
        var url = '/users/api_tokens/' + tokenId;
        $form.attr('action', url);
    });

    $('#revokeTokenForm').on('submit', function() {
        var $submitButton = $('#confirmRevokeToken');
        var originalText = $submitButton.html();
        var $container = $('[data-api-tokens]');
        var processingText = $container.data('processing-text') || 'Processing...';

        $submitButton.prop('disabled', true);
        $submitButton.html('<i class="fas fa-spinner fa-spin me-1"></i>' + processingText);

        setTimeout(function() {
            $submitButton.prop('disabled', false);
            $submitButton.html(originalText);
        }, 10000);
    });
}

function setupAdminScopeWarning() {
    var $adminCheckbox = $('[data-admin-scope]');
    if (!$adminCheckbox.length) return;

    $adminCheckbox.on('change', function() {
        if ($(this).is(':checked')) {
            $('#scope_read').prop('checked', true).prop('disabled', true);
            $('#scope_write').prop('checked', true).prop('disabled', true);
            $('#adminScopeWarning').removeClass('d-none');
        } else {
            $('#scope_read').prop('disabled', false);
            $('#scope_write').prop('disabled', false);
            $('#adminScopeWarning').addClass('d-none');
        }
    });
}

function setupScopeValidation() {
    var $form = $('#createTokenForm');
    if (!$form.length) return;

    $form.on('submit', function(e) {
        // Re-enable disabled checkboxes so their values are submitted
        $('input[name="api_token[scopes][]"]:disabled').prop('disabled', false);

        var $checkboxes = $('input[name="api_token[scopes][]"]');
        var $checked = $checkboxes.filter(':checked');

        if ($checked.length === 0) {
            e.preventDefault();
            var $alert = $('#scopeValidationAlert');
            if (!$alert.length) {
                $alert = $('<div id="scopeValidationAlert" class="alert alert-danger mt-2"><i class="fas fa-exclamation-circle me-1"></i>' +
                    ($form.data('scopes-required') || 'Please select at least one scope.') +
                    '</div>');
                $checkboxes.last().closest('.mb-4').find('.d-flex.flex-column').after($alert);
            }
            $alert.removeClass('d-none');
        }
    });

    $('input[name="api_token[scopes][]"]').on('change', function() {
        $('#scopeValidationAlert').addClass('d-none');
    });
}
